import { z } from 'zod'

enum HearingStatus {
  EXCLUIDO = 'EXCLUIDO',
  FINALIZADO = 'FINALIZADO',
  RASCUNHO = 'RASCUNHO',
}

export type HearingResponse = {
  idOitiva: number
  dataCriacao: string
  status: string
}

export const hearingStatusEnum = z.nativeEnum(HearingStatus)

export type HearingStatusEnumType = z.infer<typeof hearingStatusEnum>

export const hearingSchema = z.object({
  id: z.number(),
  numeroCnj: z.string(),
  status: hearingStatusEnum,
})

export type HearingType = z.infer<typeof hearingSchema>

export const hearingStatusOptions: { label: string; value: HearingStatusEnumType }[] = [
  {
    label: 'Excluído',
    value: HearingStatus.EXCLUIDO,
  },
  {
    label: 'Finalizado',
    value: HearingStatus.FINALIZADO,
  },
  {
    label: 'Rascunho',
    value: HearingStatus.RASCUNHO,
  },
]
